import axios from 'axios'

export default {
    namespaced: true,

    state: {
        application: sessionStorage.getItem('application'),
        schoolName: process.env.VUE_APP_THEME_SCHOOL,
        applicationGrade: {},
        applicationSubjectChoice: {},
        applicationExisting: {},
        authenticated: sessionStorage.authenticated || false,
        applicationDelete: {},
        applicationYear: null,
        applicationsLockStatus: 0,
        birthCertificatePin: null,
        dateOfBirth: null,
        applicationNumberDisplay: sessionStorage.getItem('applicationNumberDisplay') || false,
        newApplication: false,
    },

    getters: {
        getApplication (state) {
            return state.application
        },

        getSchoolName (state) {
            return state.schoolName
        },

        getApplicationGrade (state) {
            return state.applicationGrade
        },

        getApplicationSubjectChoice (state) {
            return state.applicationSubjectChoice
        },

        getApplicationExisting (state) {
            return state.applicationExisting
        },

        getAuthenticated (state) {
            return state.authenticated
        },

        getApplicationDelete (state) {
            return state.applicationDelete
        },

        getApplicationYear (state) {
            return state.applicationYear
        },

        getApplicationsLockStatus (state) {
            return state.applicationsLockStatus
        },

        getBirthCertificatePin (state) {
            return state.birthCertificatePin
        },

        getDateOfBirth (state) {
            return state.dateOfBirth
        },

        getApplicationNumberDisplay (state) {
            return state.applicationNumberDisplay
        },

        getNewApplication (state) {
            return state.newApplication
        },

    },

    mutations: {
        setApplication (state, value) {
            state.application = value
        },

        setApplicationGrade (state, value) {
            state.applicationGrade = value
        },

        setApplicationSubjectChoice (state, value) {
            state.applicationSubjectChoice = value
        },

        setApplicationExisting (state, value) {
            state.applicationExisting = value
        },

        setAuthenticated (state, value) {
            state.authenticated = value
        },

        setApplicationDelete (state, value) {
            state.applicationDelete = value
        },

        setApplicationYear (state, value) {
            state.applicationYear = value
        },

        setApplicationsLockStatus (state, value) {
            state.applicationsLockStatus = value
        },

        setBirthCertificatePin (state, value) {
            state.birthCertificatePin = value
        },

        setDateOfBirth (state, value) {
            state.dateOfBirth = value
        },

        setApplicationNumberDisplay (state, value) {
            state.applicationNumberDisplay = value  
        },

        setNewApplication (state, value) {
            state.newApplication = value
        },

    },

    actions: {
        getCSRFCookie () {
            return axios.get('/sanctum/csrf-cookie');
        },

        postApplication ({ getters }){
            const url = '/api/sixth-form-application';
            let application = getters.getApplication || {};
            return axios.post(url, application);
        },

        postApplicationGrade ({ getters }) {
            console.log('csec results', getters.getApplicationGrade);
            const url = '/api/sixth-form-application-grade';
            return axios.post(url, getters.getApplicationGrade);
        },

        postApplicationSubjectChoice ({ getters }) {
            const url = '/api/sixth-form-application-subject-choice';
            return axios.post(url, getters.getApplicationSubjectChoice);
        },

        deleteApplicationSubjectChoice ({ getters }) {
            const url = '/api/sixth-form-application-subject-choice';
            return axios.delete(url, { params: getters.getApplicationSubjectChoice})
        },

        getApplication ({ getters}) {
            const url = "/api/sixth-form-application/" +
            getters.getApplication.application_id + "/" +
            getters.getApplication.year;
            return axios.get(url);
        },

        getApplicationSubjectChoices ({ getters }) {
            const url = "/api/sixth-form-application-subject-choices/" +
            getters.getApplication.application_id + "/" +
            getters.getApplication.year;
            return axios.get(url);
        },

        getApplicationSubjectGrades ({ getters }) {
            const url = "/api/sixth-form-application-grades/" +
            getters.getApplication.application_id + "/" +
            getters.getApplication.year;
            return axios.get(url);
        },

        deleteApplicationSubjectGrades ({ getters }) {
            const url = "/api/sixth-form-application-grades";
            return axios.delete(url, { data: getters.getApplicationGrade });
        },

        getSubjectLines () {
            const url = "/api/sixth-form-application-subject-lines";
            return axios.get(url);
        },

        getCsecSubjects () {
            const url = "/api/csec-subjects";
            return axios.get(url);
        },

        getApplicationExisting ({ getters }) {
            const url = "/api/sixth-form-application-check/" + 
            getters.getApplicationExisting.applicationId + "/" +
            getters.getApplicationExisting.birthCertificatePin;
            return axios.get(url);
        },

        adminSignIn ({ getters }) {
            return axios.post('/api/admin-login', {
                name: getters.getApplicationExisting.name,
                password: getters.getApplicationExisting.password
            })
        },

        getAllApplications () {
            const url = "/api/sixth-form-applications";
            return axios.get(url);
        },

        deleteApplication ({ getters }) {
            const url = "/api/sixth-form-application";
            return axios.delete(url, { data: getters.getApplicationDelete});
        },

        downloadAcceptedSpreadsheet ({ getters }) {
            const url = "/api/sixth-form-application-accepted-excel/" + getters.getApplicationYear;
            console.log(url);
            return axios({
                method: 'get',
                url: url,
                responseType: 'arraybuffer',
            });
        },

        getApplicationsLockStatus ({ getters }) {
            const url = "/api/sixth-form-application-lock-status/" + getters.getApplicationYear;
            return axios.get(url);
        },

        postApplicationsLockStatus({ getters }) {
            const url = "/api/sixth-form-application-lock-status";
            return axios.post(url, {
                locked: getters.getApplicationsLockStatus,
                year: getters.getApplicationYear
            })
        },

        adminSignOut () {
            return axios.post('/logout');
        },

        getApplicationPeriods () {
            const url = "/api/sixth-form-application-periods";
            return axios.get(url);
        },

        getCurrentApplicationPeriod () {
            const url = "/api/sixth-form-application-current-period";
            return axios.get(url);
        },

        getInstructionsURL () {
            const url = "/api/sixth-form-application-instructions";
            return axios.get(url);
        },

        downloadApplicationsSpreadsheet ({ getters }) {
            const url = "/api/sixth-form-applications-all/" + getters.getApplicationYear;
            return axios({
                method: 'get',
                url: url,
                responseType: 'arraybuffer',
            });
        },

        getApplicationCheck ({ getters }) {
            const url = "/api/sixth-form-application-check";
            const params = {
                birth_certificate_pin : getters.getBirthCertificatePin,
                date_of_birth: getters.getDateOfBirth,
            };
            return axios.get(url, { params})
        }
    }
}